import { AVATAR_COLORS } from '@watershed/style/palette';

/**
 * Simple hash function copied from:
 * https://stackoverflow.com/a/17087158
 */
function hashStr(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    hash += charCode;
  }
  return hash;
}

/**
 * Generates a consistent color for a given name using the avatar color palette.
 * Used for avatars and collaboration features to ensure consistent coloring.
 */
export function nameToColor(name: string): string {
  const hash = hashStr(name);
  const index = hash % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}
